import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { intl } from '@trello/i18n';
import { SubscribeIcon } from '@trello/nachos/icons/subscribe';
import type { BadgesTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { useIsInboxBoard } from 'app/src/components/Inbox';
import { Badge } from './Badge';

interface SubscribedBadgeProps {
  subscribed?: boolean;
}

export const SubscribedBadge: FunctionComponent<SubscribedBadgeProps> = ({
  subscribed,
}) => {
  const isInbox = useIsInboxBoard();
  const { value: isTrelloCardImprovementEnabled } = useFeatureGate(
    'phx_trello_card_improvements',
  );
  const shouldHideBadge =
    !subscribed || (isTrelloCardImprovementEnabled && isInbox);

  if (shouldHideBadge) {
    return null;
  }

  return (
    <Badge
      title={intl.formatMessage({
        id: 'templates.badge.watch',
        defaultMessage: 'You are watching this card.',
        description:
          'Badge that indicates that a user is subscribed to a card.',
      })}
      Icon={SubscribeIcon}
      testId={getTestId<BadgesTestIds>('badge-card-subscribed')}
    />
  );
};
